import { render, staticRenderFns } from "./ABC.vue?vue&type=template&id=22e252b2"
import script from "./ABC.vue?vue&type=script&lang=js"
export * from "./ABC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports